import { OrganizationSearchCard } from '@platform/client/schemas';
import { CountryIcon, Icon, ISO3166Alpha2Code, PillBadge } from '@platform/components';

type OrganizationCardProps = {
  organization: OrganizationSearchCard;
};

export const OrganizationCard = (props: OrganizationCardProps) => {
  const { name, image, id, causes, location, countryCode, publishedUnassignedProjectCount } =
    props.organization;

  return (
    <div className='min-w-[300px] h-full flex flex-col bg-white shadow-md rounded-xl'>
      <div className='relative w-full h-[116px] flex items-center justify-center border-b border-gray-100 p-5'>
        {image ?
          <img src={image} className='h-[72px] w-full object-contain' />
        : <Icon type='building-06' size='72' additionalClassNames='text-gray-600' />}
        {publishedUnassignedProjectCount > 0 && (
          <div className='absolute top-3 right-2'>
            <PillBadge size='sm' variant='dot' color='success-25'>
              {publishedUnassignedProjectCount} project{publishedUnassignedProjectCount === 1 ? '' : 's'}
            </PillBadge>
          </div>
        )}
      </div>
      <div className='flex flex-col gap-3 p-4 flex-1'>
        <div>
          <div className='font-semibold text-base text-gray-700 line-clamp-2'>{name}</div>
          {location && (
            <div className='text-sm text-gray-500 flex flex-row items-center gap-1 mt-1'>
              {countryCode && (
                <CountryIcon alpha2={countryCode as ISO3166Alpha2Code} height={16} />
              )}
              {location}
            </div>
          )}
        </div>
        {causes.length > 0 && (
          <div className='flex flex-row gap-2 flex-wrap'>
            {causes.map((cause) => (
              <PillBadge key={cause} size='md' variant='plain' color='gray'>
                {cause}
              </PillBadge>
            ))}
          </div>
        )}
        <a
          className='w-full flex items-center justify-center gap-x-1 mt-auto h-10 px-3.5 py-2.5 border border-gray-200 rounded-lg shadow-xs text-sm font-semibold text-gray-500 bg-white cursor-pointer'
          href={`/platform/directory/organizations/${id}`}
        >
          See organization
          <Icon type='chevron-right' size='20' />
        </a>
      </div>
    </div>
  );
};
